import { render, staticRenderFns } from "./MensalidadeAluno.vue?vue&type=template&id=8da156dc"
import script from "./MensalidadeAluno.vue?vue&type=script&lang=js"
export * from "./MensalidadeAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports